import Field from '../../components/Field.jsx';

export const KIND_HELP = {
  employee: 'Works for the company',
  freelancer: 'Works for you on their own account',
  agency: 'Works for an agency you use',
};

/** "company" | "brand:<id>" | "event:<id>" ↔ { type, id } */
export const scopeKey = (s) => (!s || s.type === 'company' ? 'company' : `${s.type}:${s.id}`);
export const scopeFromKey = (k) => (k === 'company' ? { type: 'company' } : { type: k.split(':')[0], id: Number(k.split(':')[1]) });

/** What a person's link to the company covers: the whole company, a brand or one event. */
export function ScopeField({ value, onChange, scopes, companyName, error }) {
  return (
    <Field label="Covers" as="select" value={value} onChange={(e) => onChange(e.target.value)} error={error}
      hint="Their addresses count for these events only.">
      <option value="company">Every event of {companyName}</option>
      {scopes.brands.length > 0 && (
        <optgroup label="A brand's events">
          {scopes.brands.map((b) => <option key={b.id} value={`brand:${b.id}`}>{b.name}</option>)}
        </optgroup>
      )}
      {scopes.events.length > 0 && (
        <optgroup label="One event">
          {scopes.events.map((e) => <option key={e.id} value={`event:${e.id}`}>{e.name}</option>)}
        </optgroup>
      )}
    </Field>
  );
}

export function KindField({ value, onChange, kinds, error }) {
  return (
    <Field label="How they work with you" as="select" value={value} onChange={(e) => onChange(e.target.value)} error={error}>
      {Object.entries(kinds).map(([k, label]) => <option key={k} value={k}>{label} — {KIND_HELP[k]}</option>)}
    </Field>
  );
}

/** "Every event", "TechSummit (brand)", "Demo Expo 2027" */
export function coversText(c) {
  if (c.covers.type === 'company') return 'Every event';
  if (c.covers.type === 'brand') return `${c.covers.name} (brand)`;
  return c.covers.name;
}
